import { useButtonGroup as i } from "./components/ButtonGroup/hooks/useButtonGroup.js";
import { c as r } from "./index-2QXL0WYc.js";
const c = "ids-button-group-v5150", n = "ids-button-group--values-v5150", u = "ids-button-group--label-v5150", a = "ids-button-group--item-v5150", v = "ids-button-group--active-v5150", e = {
  buttonGroup: c,
  values: n,
  label: u,
  item: a,
  active: v
}, l = ({
  value: s
}) => {
  const t = i();
  if (t)
    return {
      className: r(e.item, {
        [e.active]: t.isActive(s)
      }),
      props: {
        "aria-pressed": t.isActive(s)
      },
      toggle() {
        var o;
        s !== void 0 && ((o = t == null ? void 0 : t.toggle) == null || o.call(t, s, !t.isActive(s)));
      }
    };
};
export {
  e as s,
  l as u
};
